import { Button, Grid, Modal, Space, Table } from "antd";
import type { IConvenio } from "../../../components/Interfaces";
import { CloseOutlined, ExpandAltOutlined } from "@ant-design/icons";
import { useState, type Dispatch, type SetStateAction } from "react";
import { formatarData } from "../../../utils/utilsFunctions";
import ConvenioAdesao from "./ConvenioAdesao";

const { useBreakpoint } = Grid;

interface IProps {
  convenios: IConvenio[];
  manter: number; // 1 : Inserir / 2 : Consultar / 3 : Editar;
  setLoading: Dispatch<SetStateAction<boolean>>;
  setTipLoading: Dispatch<SetStateAction<string>>;
}

const ListarConveniosAdesao = ({ convenios, manter, setLoading, setTipLoading }: IProps) => {
  const screens = useBreakpoint();
  const [serieConvenio, setSerieConvenio] = useState(0);

  const [exibirModal, setExibirModal] = useState(false);

  const colunasConvenios = [
    {
      key: "1",
      title: "Número",
      render: (convenio: IConvenio) => (
        <div>
          {convenio.numero}
        </div>
      ),
    },
    {
      key: "2",
      title: "Tipo",
      render: (convenio: IConvenio) => (
        <div>
          {convenio.tipoConvenio}
        </div>
      ),
    },
    {
      key: "3",
      title: "Data de início da vigência",
      render: (convenio: IConvenio) => (
        <div>
          {formatarData(convenio.dataInicioVigencia)}
        </div>
      ),
    },
    {
      key: "4",
      title: "Opções",
      render: (convenio: IConvenio) => (
        <>
          <Space>
            <div style={{ display: [1, 2, 3].includes(manter) ? "inline" : "none" }}>
              <ExpandAltOutlined
                title="Detalhar"
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  if (convenio.serie) {
                    setSerieConvenio(convenio.serie);
                    setExibirModal(true);
                  }
                }}
              />
            </div>
          </Space>
        </>
      ),
    }
  ];
  const handleCancel = () => {
    setExibirModal(false);
  };

  return (
    <>
      <Modal title="Convênio de adesão" open={exibirModal}
        style={{ top: 20 }}
        width={screens.xl ? 1000 : 600}
        destroyOnHidden={true}
        closable={false}
        footer={[
          <Button icon={<CloseOutlined />} shape="round" key="cancelFechar" onClick={handleCancel}>
            Fechar
          </Button>,
        ]}
      >
        <ConvenioAdesao
          serieConvenio={serieConvenio}
          setLoading={setLoading}
          setTipLoading={setTipLoading}
          manter={manter}
        />
      </Modal>
      <Table size="small" rowKey="id" columns={colunasConvenios} dataSource={convenios} />
    </>
  );
}

export default ListarConveniosAdesao;
